<template>
  <v-alert v-if="invites.length" theme="dark" rounded="lg">
    <template #prepend>
      <v-avatar class="text-10 bg-white/10!" size="70">
        <Icon name="jam:store" />
      </v-avatar>
    </template>
    <h2 class="text-4">Pending workspace invites</h2>
    <div class="mt-4 flex flex-col gap-2">
      <v-card
        v-for="(invite, i) in invites"
        :key="i"
        class="bg-transparent"
        variant="flat"
        border
      >
        <div class="pa-2 grid grid-cols-12 items-center gap-2">
          <div class="col-span-16 md:col-span-4">
            <div class="text-3.4 font-semibold">{{ invite.title }}</div>
            <div class="caption">{{ invite.expiryText }}</div>
          </div>
          <div class="col-span-8 md:col-span-4 info-card px-2 py-1">
            <div class="text-3">Workspace</div>
            <div class="text-4">{{ invite.storeCode }}</div>
          </div>
          <div class="col-span-12 md:col-span-4 md:flex md:justify-right">
            <v-btn
              @click="acceptInvite(invite)"
              size="large"
              class="text-none"
              color="white"
              height="40"
            >
              <span class="mr-2">Join workspace</span>
              <v-icon>arrow_circle_right</v-icon>
            </v-btn>
          </div>
        </div>
      </v-card>
    </div>
  </v-alert>
</template>

<script lang="ts">
import { defineComponent } from "vue";

/**
 * TODO: Merge this with GettingStarted steps
 */
export default defineComponent({
  setup() {
    const { acceptInvite, pendingInvites } = useWorkspace();

    const invites = computed(() =>
      pendingInvites.value.map((invite) => ({
        ...invite,
        title: invite.inviter
          ? `${invite.inviter} invited you to join ${invite.storeName}`
          : `You have been invited to join ${invite.storeName}`,
        expiryText: invite.expires_at
          ? "Expires in " + parseDateLike(invite.expires_at).fromNow()
          : "Never",
      }))
    );

    return {
      invites,
      acceptInvite,
    };
  },
});
</script>
